import { useState } from 'react';
import { setGg } from '../../lib/communities';

/** MOGZO's one reaction. A pressed GG turns yellow; the count updates straight away. */
export function GgButton({
  target,
  id,
  count,
  on,
  compact = false,
}: {
  target: 'post' | 'comment';
  id: string;
  count: number;
  on: boolean;
  compact?: boolean;
}) {
  const [state, setState] = useState({ on, count });
  const [busy, setBusy] = useState(false);

  async function toggle() {
    const before = state;
    const next = !state.on;
    setState({ on: next, count: Math.max(0, state.count + (next ? 1 : -1)) });
    setBusy(true);
    try {
      const saved = await setGg(target, id, next);
      setState({ on: saved.on, count: saved.ggCount });
    } catch {
      setState(before);
    } finally {
      setBusy(false);
    }
  }

  const look = state.on
    ? 'border-brand bg-brand text-ink'
    : compact
      ? 'border-transparent text-muted hover:text-ink'
      : 'border-line bg-card text-ink hover:border-muted';
  return (
    <button
      type="button"
      aria-pressed={state.on}
      aria-label={`GG (${state.count})`}
      disabled={busy}
      onClick={toggle}
      className={`inline-flex items-center gap-2 rounded-full border font-bold ${compact ? 'min-h-[34px] px-2.5 text-[13px]' : 'min-h-10 px-3.5 text-sm'} ${look}`}
    >
      <span className={`font-display ${compact ? '' : 'text-base'}`}>GG</span>
      {state.count}
    </button>
  );
}
